import React, { memo, Fragment, useState, useEffect } from "react";
// react-bootstrap
import { Row, Col, Modal, Form, Button as RBButton } from "react-bootstrap";
import { Table, Input, message, Popconfirm, Button , Select} from 'antd';
import moment from 'moment';
// components
import Card from "../../../components/bootstrap/card";
import axios from "axios";
import { SERVER_URL } from "../../../const";
import { getAllGroupsService, updateGroupService, deleteGroupService, getGroupMembersService, createGroupService } from "../../../services/UserService";

const { Search } = Input;

const edit = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const remove = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const GroupList = memo(() => {
  const [groupsList, setGroupsList] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [newGroupName, setNewGroupName] = useState("");

  const [isMembersModalVisible, setIsMembersModalVisible] = useState(false);

  const [currentGroupMembers, setCurrentGroupMembers] = useState([]);
  const [adminIecOptions, setAdminIecOptions] = useState([]);
  const [selectedGroupMember, setSelectedGroupMember] = useState(null);
  const [membersLoading, setMembersLoading] = useState(false);
  const [selectedGroupForMembers, setSelectedGroupForMembers] = useState(null);

  const userRole = localStorage.getItem('role');
  const isSuperAdmin = userRole === 'superadmin';

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await getAllGroupsService(token);
      const data = response?.data || [];
      setGroupsList(data);
    } catch (error) {
      console.error("Error fetching groups:", error);
      messageApi.error("Error fetching groups");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getAdminIecs = async () => {
    try {
       const token = localStorage.getItem('token');
       const response = await axios.get(`${SERVER_URL}/users/admin`, {
          headers: { 'Authorization': 'Bearer ' + token }
       });
       if (response && response.data && response.data.data) {
          const formatted = response.data.data.map(item => ({
             label: `${item.fullname} (${item.iec_no})`,
             value: item.iec_no, 
             key: item.iec_no
          }));
          setAdminIecOptions(formatted);
       }
    } catch (error) {
       console.error('Error fetching admin IECs:', error);
    }
  };

  useEffect(() => {
    if (isAddModalVisible) {
      getAdminIecs();
    }
  }, [isAddModalVisible]);

  useEffect(() => {
    if (!searchText) {
      setFilteredGroups(groupsList);
      return;
    }
    const lower = searchText.toLowerCase();
    const filteredData = groupsList.filter((group) => {
      // Filter by name or ID
      return (group.name && String(group.name).toLowerCase().includes(lower)) || 
             String(group.id) === lower;
    });
    setFilteredGroups(filteredData);
  }, [searchText, groupsList]);

  const handleEdit = (group) => {
    setEditingGroup(group);
    setNewGroupName(group.name);
    setIsEditModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await deleteGroupService(token, id);
      if (response && response.status === 200) {
        messageApi.success("Group deleted successfully");
        fetchData();
      } else {
        messageApi.error(response.msg || "Error deleting group");
      }
    } catch (error) {
       if (error.response && error.response.data && error.response.data.detail) {
           messageApi.error(error.response.data.detail);
       } else {
           messageApi.error("Error deleting group");
       }
    }
  };

  const handleUpdate = async () => {
    if (!newGroupName.trim()) {
      messageApi.warning("Group name cannot be empty");
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const response = await updateGroupService(token, { id: editingGroup.id, name: newGroupName });
      if (response && response.status === 200) {
        messageApi.success("Group updated successfully");
        setIsEditModalVisible(false);
        fetchData();
      } else {
        messageApi.error(response.msg || "Error updating group");
      }
    } catch (error) {
      messageApi.error("Error updating group");
    }
  };

  const handleCreate = async () => {
    if (!newGroupName.trim()) {
      messageApi.warning("Group name cannot be empty");
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const memberIecList = selectedGroupMember ? [selectedGroupMember] : [];
      const response = await createGroupService(token, newGroupName, memberIecList);
      if (response && response.status === 201) {
        messageApi.success("Group created successfully");
        setIsAddModalVisible(false);
        setNewGroupName("");
        setSelectedGroupMember(null);
        fetchData();
      } else {
        messageApi.error(response.msg || "Error creating group");
      }
    } catch (error) {
      messageApi.error("Error creating group");
    }
  };

  const handleViewMembers = async (group) => {
    setSelectedGroupForMembers(group);
    setIsMembersModalVisible(true);
    setMembersLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await getGroupMembersService(token, group.id);
      if (response && response.status === 200) {
        setCurrentGroupMembers(response.data || []);
      } else {
        messageApi.error(response.msg || "Error fetching group members");
      }
    } catch (error) {
      console.error("Error fetching members:", error);
      messageApi.error("Error fetching group members");
    } finally {
      setMembersLoading(false);
    }
  };

  const columns = [
    ...(isSuperAdmin ? [{
      title: "Action",
      dataIndex: "action",
      width: 100,
      render: (_, record) => (
        <div className="flex align-items-center list-user-action">
          <a
            onClick={() => handleEdit(record)} 
            className="btn btn-sm btn-icon btn-warning" 
            data-toggle="tooltip" data-placement="top" title="Edit"
            href="#"
          >
            <span className="btn-inner" dangerouslySetInnerHTML={{ __html: edit }}></span>
          </a>
          &nbsp;
          <Popconfirm
            title="Delete Group"
            description="Are you sure to delete this group?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <a className="btn btn-sm btn-icon btn-danger" data-toggle="tooltip" data-placement="top" title="Delete" href="#">
              <span className="btn-inner" dangerouslySetInnerHTML={{ __html: remove }}></span>
            </a>
          </Popconfirm>
        </div>
      ),
    }] : []),
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
       title: "Group Head",
       dataIndex: "groupHeadName",
       key: "groupHeadName",
       sorter: (a, b) => (a['groupHeadName'] || '').localeCompare(b['groupHeadName'] || ''),
    },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => moment(text).format('DD-MM-YYYY HH:mm'),
      sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
    },
    {
      title: "Members",
      dataIndex: "members",
      width: 150,
      render: (_, record) => (
        <RBButton 
          onClick={() => handleViewMembers(record)} 
          className="btn btn-warning" 
          style={{ 
            fontWeight: '600', 
            minWidth: '130px',
            padding: '6px 12px'
          }}
          title="View Members"
        >
          View Members
        </RBButton>
      ),
    },
  ];

  const handleSearch = (value) => {
    setSearchText(value);
  };

  return (
    <Fragment>
      {contextHolder}
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Group List</h4>
              </div>
              {isSuperAdmin && (
                <RBButton 
                  variant="primary" 
                  onClick={() => {
                    setNewGroupName("");
                    setIsAddModalVisible(true);
                  }}
                >
                  Add Group
                </RBButton>
              )}
            </Card.Header>
            <div className="p-3">
              <Select
                showSearch
                placeholder="Select Group"
                style={{ width: 300 }}
                optionFilterProp="label"
                allowClear
                value={searchText || undefined}
                onChange={(val) => {
                  setSearchText(val ? String(val) : '');
                }}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={groupsList.map(group => ({
                  label: group.name,
                  value: group.name, // Keeping name as value for simpler list filtering
                }))}
              />
            </div>
            <Card.Body className="px-0">
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredGroups}
                  rowKey="id"
                  loading={loading}
                  pagination={{ pageSize: 10 }}
                  scroll={{ x: 700 }}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={isEditModalVisible} onHide={() => setIsEditModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Group Name</Form.Label>
              <Form.Control
                type="text"
                value={newGroupName}
                onChange={(e) => setNewGroupName(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <RBButton variant="secondary" onClick={() => setIsEditModalVisible(false)}>
            Cancel
          </RBButton>
          <RBButton variant="primary" onClick={handleUpdate}>
            Update
          </RBButton>
        </Modal.Footer>
      </Modal>

      <Modal show={isAddModalVisible} onHide={() => setIsAddModalVisible(false)} centered size="md">
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="text-white">Add New Group</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">Group Name</Form.Label>
              <Form.Control
                type="text"
                value={newGroupName}
                placeholder="Ex: Regional Logistics Team"
                onChange={(e) => setNewGroupName(e.target.value)}
                className="py-2"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold">Group Members (IECs)</Form.Label>
              <Select
                showSearch
                allowClear
                style={{ width: '100%' }}
                placeholder="Search and select an IEC..."
                options={adminIecOptions}
                value={selectedGroupMember}
                onChange={setSelectedGroupMember}
                getPopupContainer={(trigger) => trigger.parentNode}
                size="large"
              />
              <Form.Text className="text-muted d-block mt-2">
                These users will be automatically assigned to the new group.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <RBButton variant="secondary" onClick={() => setIsAddModalVisible(false)}>
            Cancel
          </RBButton>
          <RBButton variant="primary" onClick={handleCreate}>
            Create
          </RBButton>
        </Modal.Footer>
      </Modal>

      <Modal show={isMembersModalVisible} onHide={() => setIsMembersModalVisible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Members of {selectedGroupForMembers?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <Table
              dataSource={currentGroupMembers}
              loading={membersLoading}
              rowKey="email"
              pagination={false}
              scroll={{ x: 'max-content' }}
              columns={[
                {
                  title: 'Name',
                  dataIndex: 'fullname',
                  key: 'fullname',
                  width: 180,
                  render: (text, record) => (
                    <span>
                      {text} {record.group_head && <span className="badge bg-warning text-dark ms-2">Head</span>}
                    </span>
                  )
                },
                {
                  title: 'Email',
                  dataIndex: 'email',
                  key: 'email',
                  width: 220,
                },
                {
                  title: 'IEC',
                  dataIndex: 'iec_no',
                  key: 'iec_no',
                  width: 120,
                },
                {
                  title: 'Role',
                  dataIndex: 'role',
                  key: 'role',
                  width: 100,
                  render: (text) => <span className="text-capitalize">{text}</span>
                }
              ]}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <RBButton variant="secondary" onClick={() => setIsMembersModalVisible(false)}>
            Close
          </RBButton>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
});

GroupList.displayName = "GroupList";
export default GroupList;
